import * as React from 'react'

import {
  Box,
  Icon,
  MediumIcon,
  Tag,
  Text,
  ToggleButton,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type Plan from 'modules/onboarding/lib/pricing/plans/Plan'

type Props = {
  icon: MediumIcon
  disabled?: boolean
  isOpen: boolean
  toggleOpen: () => void
  toggleSelectedPlan: () => void
  plan: Plan
}

const Card = ({ plan, icon, isOpen, toggleOpen, toggleSelectedPlan, disabled = false }: Props) => {
  const toggleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if ((plan.isSelected && !isOpen) || (!plan.isSelected && isOpen)) e.stopPropagation()

    toggleSelectedPlan()
  }

  return (
    <Box
      cursor="pointer"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      onClick={toggleOpen}
      gap="s24"
    >
      <Box>
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Icon.Medium icon={icon} color="grey800" />
          <Text size="300" weight="semibold">
            {plan.title}
          </Text>
          {plan.isSelected && (
            <Tag type="viridian" solid>
              {plan.activeVariantType}
            </Tag>
          )}
        </Box>
        <Box paddingLeft="s32">
          <Text size="200" color="viridian1200" weight="medium">
            {isOpen
              ? i18n.t('pricing_plans.custom_bundles.module_card.hide_details')
              : i18n.t('pricing_plans.custom_bundles.module_card.show_details')}
          </Text>
        </Box>
      </Box>
      <ToggleButton
        label={
          plan.isSelected
            ? i18n.t('pricing_plans.custom_bundles.module_card.added')
            : i18n.t('pricing_plans.custom_bundles.module_card.add')
        }
        toggled={!disabled && plan.isSelected}
        onClick={toggleClick}
        disabled={disabled}
      />
    </Box>
  )
}

export default Card
